export const JOB_FORM_NAME = "job_form";
export const JOB_DOCUMENT_NAME = "job_document";
export const DOCUMENT_LIST = "documentList";
